import {
  Image,
  Modal,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { CommonButton } from "../../../common/CommonButton";
import { AppImages } from "../../../utility/AppImages";

export default function YoutubeEmbeddingStepsPopup(props) {
  const { showModal = false, setShowModal } = props;

  const styles = useStyles();
  const onCloseClick = () => {
    setShowModal(false);
  };
  const deviceSize = useDeviceSize();
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <TouchableOpacity
          style={styles.overlayBackground}
          onPress={onCloseClick}
        />

        <View style={styles.mainView}>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XL
                  ? AppFontStyle.BOLD_ANYBODY_18
                  : AppFontStyle.BOLD_ANYBODY_12,
                {},
              ]}
            >
              🔧 Steps to Enable Embedding for YouTube Live Streams:
            </Text>{" "}
            <TouchableOpacity onPress={onCloseClick} activeOpacity={0.5}>
              <Image
                source={AppImages.icCloseWhiteSvg}
                style={{
                  height:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 16
                      : 28,
                  width:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 16
                      : 28,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
          </View>

          <View style={styles.divider} />
          <View
            style={{
              flexDirection: "row",
              gap: 5,
            }}
          >
            <Text style={[styles.descText, {}]}>1.</Text>
            <View style={{ gap: 5 }}>
              <Text style={[styles.boldText, {}]}>Go to YouTube Studio</Text>
              <Text style={[styles.descText, {}]}>
                Visit:{" "}
                <TouchableOpacity
                  onPress={() => {
                    window.open("https://studio.youtube.com", "_blank");
                  }}
                >
                  <Text
                    style={[styles.descText, { color: AppColors.blue_D6BBFB }]}
                  >
                    {" "}
                    https://studio.youtube.com
                  </Text>
                </TouchableOpacity>
              </Text>
              <Text style={[styles.descText, {}]}>
                Log in with the YouTube account you’ll be streaming from.
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              gap: 5,
            }}
          >
            <Text style={[styles.descText, {}]}>2.</Text>
            <View style={{ gap: 5 }}>
              <Text style={[styles.boldText, {}]}>
                Navigate to the "Content" Section
              </Text>
              <Text style={[styles.descText, {}]}>
                On the left-hand sidebar, click on{" "}
                <Text style={[styles.boldText, {}]}> “Content” </Text>
                (🎬 icon).
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              gap: 5,
            }}
          >
            <Text style={[styles.descText, {}]}>3.</Text>
            <View style={{ gap: 5, width: "90%" }}>
              <Text style={[styles.boldText, {}]}>Go to the “Live” Tab</Text>
              <Text style={[styles.descText, {}]}>
                At the top, switch from "Videos" to{" "}
                <Text style={[styles.boldText, {}]}> "Live" </Text> to see your
                scheduled or past live streams.
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              gap: 5,
            }}
          >
            <Text style={[styles.descText, {}]}>4.</Text>
            <View style={{ gap: 5 }}>
              <Text style={[styles.boldText, {}]}>
                Select the Stream You Want to Edit
              </Text>
              <Text style={[styles.descText, {}]}>
                Click on the stream you want to embed.
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              gap: 5,
            }}
          >
            <Text style={[styles.descText, {}]}>5.</Text>
            <View style={{ gap: 5, width: "90%" }}>
              <Text style={[styles.boldText, {}]}>Open “Details” Tab</Text>
              <Text style={[styles.descText, {}]}>
                This will open the stream settings. Scroll down and click{" "}
                <Text style={[styles.boldText, {}]}>“Show More”</Text>.
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              gap: 5,
            }}
          >
            <Text style={[styles.descText, {}]}>6.</Text>
            <View style={{ gap: 5, width: "90%" }}>
              <Text style={[styles.boldText, {}]}>
                Find the "License and Distribution" Section
              </Text>
              <Text style={[styles.descText, {}]}>
                Under this section, locate the checkbox:{" "}
                <Text style={[styles.boldText, {}]}>"Allow embedding"</Text>–
                make sure this box is{" "}
                <Text style={[styles.boldText, {}]}>checked</Text>
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              gap: 5,
            }}
          >
            <Text style={[styles.descText, {}]}>7.</Text>
            <View style={{ gap: 5, width: "90%" }}>
              <Text style={[styles.boldText, {}]}>Save the Changes</Text>
              <Text style={[styles.descText, {}]}>
                Scroll to the bottom and click{" "}
                <Text style={[styles.boldText, {}]}>“Save”</Text> to apply the
                new settings.
              </Text>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      height: "auto",
      backgroundColor: AppColors.purple_453B50,
      padding: 24,
      borderRadius: 24,
      gap: 10,
      width: "45%",
    },
    overlayBackground: {
      position: "absolute",
      width: "100%",
      height: "100%",
    },
    boldText: {
      ...AppFontStyle.BOLD_ANYBODY_14,
    },
    descText: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
    },

    divider: {
      height: 2,
      alignSelf: "center",
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "100%",
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "95%",
      },
      boldText: {
        ...AppFontStyle.BOLD_ANYBODY_12,
      },
      descText: {
        ...AppFontStyle.REGULAR_ANYBODY_12,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainView: {
        width: "95%",
      },
      boldText: {
        ...AppFontStyle.BOLD_ANYBODY_12,
      },
      descText: {
        ...AppFontStyle.REGULAR_ANYBODY_12,
      },
    },
  }
);
